export default "__VITE_ASSET__CFz22QiB__"